import { ref } from 'vue'
import { useRouter } from 'vue-router'

const customGoBack = ref(null)

export function useGoBack() {
  const router = useRouter()

  const goBack = () => {
    if (customGoBack.value) {
      customGoBack.value()
    } else {
      router.back()
    }
  }

  const setCustomGoBack = (fn) => {
    customGoBack.value = fn
  }

  const resetGoBack = () => {
    customGoBack.value = null
  }

  return {
    goBack,
    setCustomGoBack,
    resetGoBack,
  }
}
